import { render, staticRenderFns } from "./patient-manage-modal.vue?vue&type=template&id=8f8965a6&"
import script from "./patient-manage-modal.vue?vue&type=script&lang=js&"
export * from "./patient-manage-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports